import * as Immutable from 'immutable';
import ProductPublishJobStore from './ProductPublishJobStore';
import type { ProductPublishJobPayload } from './ProductPublishJobStore';

export interface ProductPublishSummaryPayload {
	jobs: ProductPublishJobPayload[],
}

export interface ProductPublishResponse {
	batch_id: string,
	jobs: ProductPublishJobPayload[],
}

export interface IProductPublishSummaryStore {
	jobs: Immutable.List<ProductPublishJobStore>,
}

const defaultProductPublishSummaryStore = Immutable.Record<IProductPublishSummaryStore>({
	jobs: Immutable.List<ProductPublishJobStore>(),
});

export default class ProductPublishSummaryStore extends defaultProductPublishSummaryStore implements IProductPublishSummaryStore {}
